import { Route } from "react-router-dom"
import React from "react"

import { getToken } from "../services/helper"
import ROUTES from "../services/routes"
import useHistoryCustom from "../hooks/useHistoryCustom"

const PublicRoute = ({ ...rest }) => {
  const history = useHistoryCustom()

  if (getToken()) history.push(ROUTES.HOME)

  return <Route {...rest} />
}

export default PublicRoute
